import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  text: "",
  searchText: "",
  language: { code: "KOR", name: "대한민국", flag: "https://flagcdn.com/kr.svg", lang: "ko" },
  authorization: { auth: false, authDate: "", authType: "" },
};

const LocalStorageSlice = createSlice({
  name: "LocalStorage",
  initialState,
  reducers: {
    setText(state, action) {
      state.text = action.payload;
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setAuthorization(state, action) {
      state.authorization = action.payload;
    },
  },
});

export const LocalStorageActions = LocalStorageSlice.actions;
export default LocalStorageSlice.reducer;
